import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckCircle,
  faCubes,
} from "@fortawesome/free-solid-svg-icons";
import { PRIMARY } from "../../../vars/vars";
import React from "react";

export const services = [
  {
    icon: <FontAwesomeIcon icon={faCheckCircle} size={"2x"} color={PRIMARY} />,
    header: "EXPERT ADVICE",
    text: "Confirm the correct fitment, first time.",
  },
  {
    icon: <FontAwesomeIcon icon={faCubes} size={"2x"} color={PRIMARY} />,
    header: "LIVE STOCK CHECK",
    text: "To ensure consistent availability.",
  },
  {
    icon: <FontAwesomeIcon icon={faCalendarAlt} size={"2x"} color={PRIMARY} />,
    header: "Reliable & Fast delivery",
    text: "Check our shipping conditions here.",
    to: "/shipping",
  },
];
